import { IPoliticResponse } from "../models/get-politic.model";

export const listPoliticsAdapter = (params: IPoliticResponse) => {
    return {
        data: {
            politics: params.data.politics.map(politic => {
                return {
                    id: politic.id,
                    name: politic.name,
                    description: politic.description,
                    visited: politic.isVisited === 1
                }
            }),
            total: params.data.total,
            totalVisited: params.data.totalVisited
        }
    }
}